import React from "react"
import {ManagedSolutionsApplicationForm} from "../../resources/managedSolutions"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import classNames from "classnames"
import {kebabCase, startCase} from "lodash"
import moment from "moment"
import {Meta} from "../../resources/common"
import {Link, useNavigate} from "react-router-dom"

interface ManagedSolutionsApplicationFormsTableProps {
	applicationForms: Array<ManagedSolutionsApplicationForm>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	fullHeight?: boolean
	meta?: Meta
	sortBy?: string
	sortFunction?: () => void
}

export default function ManagedSolutionsApplicationFormsTable({
	applicationForms,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	fullHeight,
	meta,
	sortBy,
	sortFunction,
}: ManagedSolutionsApplicationFormsTableProps) {
	const noContent = applicationForms.length === 0
	const navigate = useNavigate()

	return (
		<div className={"managed-solutions-application-forms-table"}>
			<DataTable isEmpty={noContent} fullHeight={fullHeight} noContentText="No application forms yet">
				<DataTableHead className={classNames(!fullHeight && "no-sticky")}>
					<DataTableRow>
						<DataTableCell>ID</DataTableCell>
						<DataTableCell>User IDs</DataTableCell>
						<DataTableCell>Stage</DataTableCell>
						<DataTableCell>Application</DataTableCell>
						<DataTableCell clickable onClick={() => sortFunction?.()} sortable sortApplied={sortBy === "createdAt"}>
							Created At
						</DataTableCell>
						<DataTableCell>Updated At</DataTableCell>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{applicationForms.map((applicationForm) => {
						const stage = applicationForm.attributes.stage
						const createdAt = applicationForm.attributes.createdAt
						const updatedAt = applicationForm.attributes.updatedAt
						const applicationId = applicationForm.relationships?.application?.data?.id

						return (
							<DataTableRow
								key={applicationForm.id}
								onClick={(e) => {
									e.preventDefault()
									navigate(`/managed-solutions/application-forms/${applicationForm.id}`)
								}}
							>
								<DataTableCell className="data-table-id-cell">{applicationForm.id}</DataTableCell>
								<DataTableCell>
									{applicationForm.attributes.userIds.map((userId, index) => (
										<div key={index}>{userId}</div>
									))}
								</DataTableCell>
								<DataTableCell>
									{stage ? (
										<div
											className={classNames("application-forms-stage", kebabCase(stage), {
												approved: stage.toLowerCase() === "completed",
											})}
										>
											{startCase(stage)}
										</div>
									) : (
										"-"
									)}
								</DataTableCell>
								<DataTableCell>
									{applicationId ? (
										<Link
											className="link"
											to={`/managed-solutions/applications/${applicationId}`}
											onClick={(e) => e.stopPropagation()}
										>
											{applicationId}
										</Link>
									) : (
										"-"
									)}
								</DataTableCell>
								<DataTableCell>{createdAt ? moment(createdAt).format("L LT") : "-"}</DataTableCell>
								<DataTableCell>{updatedAt ? moment(updatedAt).format("L LT") : "-"}</DataTableCell>
							</DataTableRow>
						)
					})}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
